import { render, staticRenderFns } from "./CompanyComplianceSummary.vue?vue&type=template&id=478f7fb1"
import script from "./CompanyComplianceSummary.vue?vue&type=script&lang=js"
export * from "./CompanyComplianceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports